import { render, staticRenderFns } from "./OrderNotes.vue?vue&type=template&id=1574a3bd"
import script from "./OrderNotes.vue?vue&type=script&lang=ts"
export * from "./OrderNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports